export const actionTypes = {
  ADD: 'ADD',
  MINUS: 'MINUS',
  LOAD_DATA: 'LOAD_DATA',
  LOAD_DATA_SUCCESS: 'LOAD_DATA_SUCCESS',
};

export const addCount = () => dispatch => {
  return dispatch({ type: actionTypes.ADD });
};
export const minusCount = () => dispatch => {
  return dispatch({ type: actionTypes.MINUS });
};
export const loadData = () => dispatch => {
  return dispatch({ type: actionTypes.LOAD_DATA });
};

//saga后的reduce方法
export function loadDataSuccess(data) {
  return {
    type: actionTypes.LOAD_DATA_SUCCESS,
    data,
  };
}
